// src/components/Dashboard/ProductCard.jsx
import React from "react";

const ProductCard = ({ product, maxQuantity }) => (
  <div className="flex items-center p-3 hover:bg-gray-50 rounded-lg transition-colors">
    <div className="w-16 h-16 flex-shrink-0">
      <img src={product.image} alt={product.name} className="w-full h-full object-contain rounded-lg" />
    </div>
    <div className="flex-grow ml-4">
      <div className="flex justify-between items-baseline mb-1">
        <div>
          <span className="text-sm font-medium text-gray-600">#{product.code}</span>
          <h4 className="text-sm font-medium text-gray-900">{product.name}</h4>
        </div>
        <span className="text-sm font-semibold text-blue-600">
          {product.quantity.toLocaleString()} un
        </span>
      </div>
      <div className="relative h-2 bg-gray-100 rounded-full overflow-hidden">
        <div
          className="absolute top-0 left-0 h-full bg-blue-500 rounded-full transition-all duration-1000 ease-out"
          style={{ width: `${(product.quantity / maxQuantity) * 100}%` }}
        />
      </div>
    </div>
  </div>
);

export default ProductCard;
